import { render, staticRenderFns } from "./questionUserManagement.vue?vue&type=template&id=313cdaf4"
import script from "./questionUserManagement.vue?vue&type=script&lang=js"
export * from "./questionUserManagement.vue?vue&type=script&lang=js"
import style0 from "./questionUserManagement.vue?vue&type=style&index=0&id=313cdaf4&prod&scpoed=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports